export class InitiatorIdentity {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "InitiatorType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return InitiatorIdentity.attributeTypeMap;
    }
    constructor() {
    }
}
